import _ from 'lodash';
import axios from 'axios';
import qs from 'querystring';
import postal from 'postal';
import 'jquery-appear-original';
import csrfToken from '../shared/meta';
import { recordStatisticsEvent } from '../services/statistics-service';

// NOTE This can't use the $(document).on(event,selector,cb) trick because
// viewables use jquery.appear, which doesn't support dynamic DOM elements
// without being explicitly attached. feeds.js uses postal to trigger attaching
// to new wires.
function attachAppearEventToViewables(viewables) {
  const props = ['id', 'event', 'statisticable', 'page'];
  let timeout = null;
  let statisticsData = [];

  function deferBatchCreate() {
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      const headers = {
        'X-CSRF-Token': csrfToken(),
        'Content-Type': 'application/x-www-form-urlencoded',
      };
      const copy = statisticsData;

      statisticsData = [];

      const body = {};
      _.each(copy, (d, i) => {
        _.each(props, p => {
          body[`statistics_data[${i}][${p}]`] = d[p];
        });
        if (d.clicked_url) {
          body[`statistics_data[${i}][clicked_url]`] = d.clicked_url;
        }
      });
      axios
        .post('/statistic_events/batch_create.json', qs.stringify(body), { headers })
        .catch(() => {
          _.each(copy, datum => {
            statisticsData.push(_.pick(datum, [...props, 'clicked_url']));
          });
        });
    }, 1000);
  }

  _.each(viewables, viewable => {
    $(viewable).appear().on('appear.viewable', function handler() {
      deferBatchCreate();
      const $this = $(this);
      const data = $this.data();

      statisticsData.push(_.pick(data, props));
      $this.off('appear.viewable');
    });
  });

  $.force_appear();
}

function attachLinkClickEventToClickables() {
  $(document).on(
    'click',
    '[data-event-type="click"]',
    function clickHandler() {
      const $clickable = $(this);
      const parentData = $clickable.parents('article.wire').data();

      recordStatisticsEvent({
        id: parentData.id,
        event: $clickable.data().event,
        statisticable: parentData.statisticable,
        clicked_url: $clickable.attr('href'),
      });
    },
  );
}

// NOTE This is the preferred method for attaching statisticable events to components.
// All of the data for the event should be on the element, not requiring traversal
// to a containing article (which doesn't exist for sidebar links for example).
// Eg:
//  <a href="..."
//     data-statisticable-event="link_click"
//     data-statisticable-type="wire"
//     data-statisticable-id="123">...</a>
// The [data-statisticable-event-type] attribute is optional and default to 'link_click'
function attachClickEvents() {
  document.querySelectorAll('[data-statisticable-event="click"]').forEach(elem => {
    elem.addEventListener('click', event => {
      let { target } = event;

      while (!!target && target.dataset.statisticableEvent !== 'click') {
        target = target.parentElement;
      }

      const {
        dataset: {
          statisticableEventType,
          statisticableType,
          statisticableId,
        },
      } = target;

      recordStatisticsEvent({
        event: statisticableEventType || 'link_click',
        statisticable: statisticableType,
        id: statisticableId,
        clicked_url: target.getAttribute('href'),
        page: window.location.pathname,
      });
    });
  });
}

function attachWireBodyClickEvents() {
  $(document).on(
    'click',
    'section.wire-body.full-wire a',
    event => {
      const $target = $(event.target);
      const wireData = $target.parents('article.wire').data();
      // In the case of an invalid URL, we want this to break so that the recording
      // won't proceed.
      // Andd someone needs to fix a broken URL!
      const clickedUrl = new window.URL($target.attr('href'), window.location.origin);
      const isInternalUrl = _.get(clickedUrl, 'hostname') === window.location.hostname;

      recordStatisticsEvent({
        event: isInternalUrl ? 'internal_link_click' : 'external_link_click',
        statisticable: 'wire',
        id: wireData.id,
        clicked_url: _.get(clickedUrl, 'href'),
      });
    },
  );
}

function attachPdfMediaClickEvents() {
  $(document).on(
    'click',
    'article.wire .wire-media-carousel__pdf a',
    event => {
      const $target = $(event.target);
      const wireData = $target.parents('article.wire').data();
      const clickedUrl = $target.attr('href');

      recordStatisticsEvent({
        event: 'pdf_link_click',
        statisticable: 'wire',
        id: wireData.id,
        clicked_url: clickedUrl,
      });
    },
  );
}

export default function bootstrap() {
  $(() => {
    attachAppearEventToViewables($('[data-event-type="view"]'));
    attachLinkClickEventToClickables();
    attachClickEvents();
    attachWireBodyClickEvents();
    attachPdfMediaClickEvents();

    postal.subscribe({
      channel: 'commands.statistics',
      topic: 'attach-to-viewables',
      callback: data => attachAppearEventToViewables(data),
    });
  });
}
